import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllPatrimonioCentroCustoUseCase } from "../../../presentation/useCases/read/get_all_patrimonio_centro_custo_use_case";
import { PatrimonioCentroCustoListaModel } from "../../models/patrimonio_centro_custo_lista";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllPatrimonioCentroCustoUseCase
 */

export class GetAllPatrimonioCentroCustoUseCase
  extends BasePaginatedUseCase<PatrimonioCentroCustoListaModel>
  implements IGetAllPatrimonioCentroCustoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllPatrimonioCentroCusto(
    status?: number | null,
    idsCentroCusto?: number[] | null,
    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const response = await this.repository.getAllPatrimonioCentroCusto(
      status ?? null,
      idsCentroCusto ?? null,
      page ?? 1,
      rowsPerPage ?? 100,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
